import styled, { css } from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
export const ContainerStyled = styled.nav `
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const ListStyled = styled.ul `
  display: flex;
  justify-content: center;
  align-items: center;
  list-style-type: none;
  padding: 0;
`;
export const ItemStyled = styled.li `
  margin: 0 ${pxToRems(4)};
`;
const determineInactiveBackgroundColour = (props) => {
    const { overrideColours, theme } = props;
    return !overrideColours?.inactiveBackgroundColour
        ? theme.ColorWhiteOpacity100
        : overrideColours?.inactiveBackgroundColour;
};
const determineInactiveBorderColour = (props) => {
    const { overrideColours, theme } = props;
    return !overrideColours?.inactiveBorderColour
        ? theme.ColorBlackOpacity10
        : overrideColours?.inactiveBorderColour;
};
const determineInactiveTextColour = (props) => {
    const { overrideColours, theme } = props;
    return !overrideColours?.inactiveTextColour
        ? theme.ColorButtonSolidSecondaryBackground
        : overrideColours?.inactiveTextColour;
};
const determineHoverBorderColour = (props) => {
    const { overrideColours, theme } = props;
    return !overrideColours?.hoverBorderColour
        ? theme.ColorButtonSolidSecondaryBackground
        : overrideColours?.hoverBorderColour;
};
const determineActiveBackgroundColour = (props) => {
    const { overrideColours, theme } = props;
    return !overrideColours?.activeBackgroundColour
        ? theme.ColorButtonSolidSecondaryBackground
        : overrideColours?.activeBackgroundColour;
};
const determineActiveBorderColour = (props) => {
    const { overrideColours, theme } = props;
    return !overrideColours?.activeBorderColour
        ? theme.ColorButtonSolidSecondaryBackground
        : overrideColours?.activeBorderColour;
};
const determineActiveTextColour = (props) => {
    const { overrideColours, theme } = props;
    return !overrideColours?.activeTextColour
        ? theme.ColorButtonSolidSecondaryText
        : overrideColours?.activeTextColour;
};
export const ItemLinkStyled = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: ${pxToRems(40)};
  height: ${pxToRems(40)};
  border: 2px solid ${(props) => determineInactiveBorderColour(props)};
  font-weight: 600;
  font-size: ${pxToRems(14)};
  line-height: 1.5;
  background-color: ${(props) => determineInactiveBackgroundColour(props)};
  color: ${(props) => determineInactiveTextColour(props)};
  cursor: pointer;

  &:hover {
    border-color: ${(props) => determineHoverBorderColour(props)};
  }

  ${({ isActive }) => isActive &&
    css `
      background: ${(props) => determineActiveBackgroundColour(props)};
      border-color: ${(props) => determineActiveBorderColour(props)};
      color: ${(props) => determineActiveTextColour(props)};
      pointer-events: none;
    `}
`;
const determineArrowBackgroundColour = (props) => {
    const { customArrowColour, theme } = props;
    return !customArrowColour
        ? theme.ColorButtonSolidSecondaryBackground
        : customArrowColour;
};
export const ArrowLinkStyled = styled.button `
  border: none;
  background-color: transparent;
  cursor: pointer;
  height: ${pxToRems(30)};
  padding: 0;
  position: relative;
  width: ${pxToRems(30)};

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  ${({ direction }) => direction === 'next'
    ? css `
          margin-left: ${pxToRems(10)};
        `
    : css `
          transform: rotate(180deg);
          margin-right: ${pxToRems(10)};
        `}

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    fill: ${(props) => determineArrowBackgroundColour(props)};
    margin: 0 auto;
    width: ${pxToRems(10)};
  }
`;
export const EllipsisStyled = styled.div `
  pointer-events: none;
  padding: 0 ${pxToRems(4)};
  color: ${({ theme }) => theme.ColorGrey400};
`;
//# sourceMappingURL=pagination.styles.js.map